import { getConversationMessages, createConversation, sendConversationMessage } from '../adapter/api'
import { streamMessage } from '../adapter/stream'
import { adaptConversationMessagesResponse } from '../adapters/conversationMessages.adapter'

const mockConversationId = 'demo-conversation'

// 解析SSE载荷（根据原来的逻辑）
function parseSsePayloads(raw) {
  return raw
    .split('\n')
    .map((line) => line.trim())
    .filter((line) => line.startsWith('data:'))
    .flatMap((line) => {
      try {
        const payload = line.slice(5).trim()
        return payload ? [JSON.parse(payload)] : []
      } catch {
        return []
      }
    })
}

function pickConversationId(raw) {
  if (typeof raw === 'string') {
    for (const payload of parseSsePayloads(raw)) {
      const extra = payload.extra && typeof payload.extra === 'object' ? payload.extra : {}
      if (typeof extra.conversation_id === 'string' && extra.conversation_id) {
        return extra.conversation_id
      }
      if (typeof payload.conversation_id === 'string' && payload.conversation_id) {
        return payload.conversation_id
      }
    }
    return ''
  }

  const record = (raw && typeof raw === 'object' ? raw : {})
  const data = (record.data && typeof record.data === 'object' ? record.data : record)
  return typeof data.conversation_id === 'string' && data.conversation_id ? data.conversation_id : ''
}

export async function fetchMessages(conversationId, pageNum = 1) {
  const raw = await getConversationMessages({
    conversationId,
    pageNum,
    pageSize: 10,
  })

  // 根据真实 API 的响应结构处理
  return adaptConversationMessagesResponse(raw.data || raw, conversationId)
}

export async function ensureConversation(conversationId, agentId, thirdUserId) {
  if (conversationId) return conversationId

  if (!agentId) {
    throw new Error('缺少 agent_id，无法创建会话')
  }

  const raw = await createConversation({
    agentId: agentId,
    thirdUserId: thirdUserId || undefined,
  })

  const createdConversationId = pickConversationId(raw.data || raw)
  if (!createdConversationId) {
    return mockConversationId // fallback
  }

  return createdConversationId
}

// 供非流式使用的方法
export async function submitMessage(params) {
  const conversationId = await ensureConversation(params.conversationId, params.agentId, params.thirdUserId)

  return sendConversationMessage({
    ...params,
    conversationId,
  })
}

// 供流式使用的方法，直接在 repository 里包装 streamMessage
export async function streamConversation(params, options) {
  // ensureConversation 等逻辑视需求前置处理
  const conversationId = await ensureConversation(params.conversationId, params.agentId, params.thirdUserId)

  return streamMessage({
    message: params.message,
    conversation_id: conversationId,
    agent_id: params.agentId,
    ...(params.thirdUserId ? { third_user_id: params.thirdUserId } : {}),
    ...(params.instructions ? { instructions: params.instructions } : {})
  }, options)
}
